<template>
  <main role="main" class="col content-spacing">
    <div
      class="d-flex justify-content-between align-items-start pt-3 pb-2 mb-3 border-bottom"
    >
      <div class="d-inline-flex flex-grow-2">
        <h1 class="h2">Perguntas e Respostas</h1>

        <hr class="vertical-bar" />
      </div>

      <div class="mb-3 mr-3 flex-grow-1">
        <b-form-select v-model="viewData.profile" @change="search">
          <option value>Todos os perfis</option>
          <option value="consumer">Consumidor</option>
          <option value="trader">Trader</option>
          <option value="investor">Investidor</option>
          <option value="partner">Parceiro</option>
        </b-form-select>
      </div>

      <div class="mr-3 flex-grow-1">
        <b-form-input
          autofocus
          v-on:keyup.enter="search"
          v-model="viewData.search"
          placeholder="Digite um termo e pressione enter para buscar"
        ></b-form-input>
      </div>

      <BaseButtonComponent to="/faq/new" variant="primary-action">
        Novo
      </BaseButtonComponent>
    </div>

    <loading-list v-if="viewData.loading"></loading-list>
    <div
      class="d-flex justify-content-between flex-column h-100"
      v-else-if="!viewData.loading && state.list && state.list.length > 0"
    >
      <v-table>
        <thead>
          <tr>
            <td>Pergunta</td>
            <td>Perfil</td>
            <td>Categoria</td>
            <td></td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in state.list" :key="item.id">
            <td>{{ item.question }}</td>
            <td>
              <span v-if="item.profile === 'consumer'">Consumidor</span>
              <span v-else-if="item.profile === 'trader'">Comercializador</span>
              <span v-else-if="item.profile === 'investor'">Investidor</span>
              <span v-else>Parceiro</span>
              <span></span>
            </td>
            <td>
              <span v-if="item.category === 'ECONOMIZE'">Economize</span>
              <span v-else-if="item.category === 'COMERCIALIZE'"
                >Comercialize</span
              >
              <span v-else-if="item.category === 'INVISTA'">Invista</span>
              <span v-else-if="item.category === 'ENERGIA'">Energia</span>
              <span v-else-if="item.category === 'OUTRAS'">Outras</span>
              <span v-else-if="item.category === 'VEINS'">Veins</span>
              <span v-else-if="item.category === 'LEGISLACAO'">Legislação</span>
              <span></span>
            </td>
            <td style="text-align: right">
              <BaseButtonComponent
                :to="`/faq/edit/${item.id}`"
                size="sm"
                v-b-tooltip.hover
                title="Editar"
                variant="primary-action"
              >
                <b-icon icon="pencil-square" aria-hidden="true"></b-icon>
              </BaseButtonComponent>
              <BaseButtonComponent
                @click="() => remove(item)"
                size="sm"
                v-b-tooltip.hover
                title="Excluir"
                variant="danger"
              >
                <b-icon icon="trash" aria-hidden="true"></b-icon>
              </BaseButtonComponent>
            </td>
          </tr>
        </tbody>
      </v-table>

      <b-pagination-nav
        class="mt-3"
        :link-gen="linkGen"
        :number-of-pages="state.pageCount"
        use-router
      ></b-pagination-nav>
    </div>
    <empty-list v-else-if="!viewData.loading"></empty-list>
  </main>
</template>

<script>
import helpers from '../../vue/helpers';
import { Api } from '../../vue/api';
import { BaseButtonComponent } from '../../ui/buttons';

const API = new Api();

export default {
  name: 'faq-index',
  data: function() {
    return {
      state: {
        list: [],
        page: 1,
        pageCount: 1,
        count: 0,
      },
      viewData: {
        loading: true,
        search: '',
        profile: '',
      },
    };
  },
  beforeMount: async function() {
    if (this.$route.query && this.$route.query.search) {
      this.viewData.search = this.$route.query.search;
    }

    if (this.$route.query && this.$route.query.profile) {
      this.viewData.profile = this.$route.query.profile || '';
    }

    await this.getAll();
  },
  methods: {
    linkGen(pageNum) {
      return pageNum === 1 ? '?' : `?page=${pageNum}`;
    },
    search() {
      this.$router.push({
        query: {
          page: 1,
          ...(this.viewData.search ? { search: this.viewData.search } : {}),
          ...(this.viewData.profile ? { profile: this.viewData.profile } : {}),
        },
      });
    },
    async getAll() {
      try {
        this.viewData.loading = true;

        const result = await API.post('/execute', {
          path: '/faqs' + helpers.toQueryString(this.$route.query),
          method: 'get',
        });

        this.state = { ...result.model };
        this.viewData.loading = false;
      } catch (ex) {
        this.$toast.error(helpers.getFirstError(ex));
      }
    },
    async remove(item) {
      const ok = await this.$bvModal.msgBoxConfirm(
        `Deseja mesmo excluir [${item.question}] ?`,
        {
          title: 'Confirmar Exclusão',
          size: 'md',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Sim',
          cancelTitle: 'Não',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
        },
      );

      if (!ok) {
        return;
      }

      try {
        this.viewData.loading = true;

        const result = await API.post('/execute', {
          path: '/faq/' + item.id,
          method: 'delete',
        });

        this.$toast.success('FAQ excluída com sucesso');
        await this.getAll();
      } catch (ex) {
        this.$toast.error(helpers.getFirstError(ex));
      }
    },
  },
  components: {
    BaseButtonComponent,
  },
};
</script>
